package com.vamvisions.main.api

/** Endpoint paths shared by the server routes and the web client. */
object ApiRoutes {
    const val BASE = "/api/v1"

    /** Messages sent from the website's contact form. */
    const val CONTACT_MESSAGES = "$BASE/contact-messages"

    object Portfolio {
        const val ROOT = "$BASE/portfolio"
        const val PROJECTS = "$ROOT/projects"
        const val EXPERIENCES = "$ROOT/experiences"
        const val DOCUMENTS = "$ROOT/documents"

        /** Public image files referenced by projects and documents. Not under [BASE]. */
        const val MEDIA = "/media"

        fun document(slug: String): String = "$DOCUMENTS/$slug"
    }
}
